import { render, staticRenderFns } from "./BridgeTokenSelection.vue?vue&type=template&id=c7780882&scoped=true"
import script from "./BridgeTokenSelection.vue?vue&type=script&lang=ts"
export * from "./BridgeTokenSelection.vue?vue&type=script&lang=ts"
import style0 from "./BridgeTokenSelection.vue?vue&type=style&index=0&id=c7780882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7780882",
  null
  
)

export default component.exports